import React from 'react';
import { bool, func } from 'prop-types';
import * as R from 'ramda';
import { Drawer, useMediaQuery, useTheme } from '@mui/material';

// Utils
import { useGetAffiliateOptions, useUserRolePermissions } from 'hooks';

// Components
import Sidebar from './sidebar/Sidebar.connector';
import MainPanel from './main-panel/MainPanel.connector';
import NonSubscriberPage from './non-subscriber-page/NonSubscriberPage';

const RackWaitTimes = props => {
  const theme = useTheme();
  const { mobileDrawerOpen, setMobileDrawerOpen } = props;
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  const { currentAffiliate } = useUserRolePermissions();

  const affiliates = useGetAffiliateOptions(['hasActiveSubscription']);

  return (
    !R.isNil(currentAffiliate) && (
      <>
        {affiliates.length > 0 ? (
          <>
            <Sidebar />
            {mdUp ? (
              <MainPanel />
            ) : (
              <Drawer
                anchor="right"
                onClose={() => setMobileDrawerOpen(false)}
                open={mobileDrawerOpen}
                slotProps={{
                  paper: {
                    paper: {
                      sx: {
                        backgroundColor: 'surface.light',
                        // removes 1 px of white space on left hand side
                        left: -1,
                        top: theme.spacing(7),
                        width: '100%',
                      },
                    },
                  },
                }}
                variant="persistent"
              >
                <MainPanel />
              </Drawer>
            )}
          </>
        ) : (
          <NonSubscriberPage />
        )}
      </>
    )
  );
};
RackWaitTimes.propTypes = {
  mobileDrawerOpen: bool.isRequired,
  setMobileDrawerOpen: func.isRequired,
};

export default RackWaitTimes;
